/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

/**
 *     Import
 *     - Images
 */
import { CasksIcon } from '../../../../../images/icons/AssetsIcons/Casks'
import { WineIcon } from '../../../../../images/icons/AssetsIcons/Wine'

/**
 *     Import
 *     - CSS
 */
import '../../styles/Step03.css'

const REGEXP = '^(?!(?:^[-+]?[0.]+(?:[Ee]|$)))(?!(?:^-))(?:(?:[+-]?)(?=[0123456789.])' +
    '(?:(?:(?:[0123456789]+)(?:(?:[.])(?:[0123456789]*))?|(?:(?:[.])(?:[0123456789]+))))' +
    '(?:(?:[Ee])(?:(?:[+-]?)(?:[0123456789]+))|))$'

/**
 * UnspecifiedTable class
 *
 * @class UnspecifiedTable
 * @extends {React.Component<any, any>}
 */
class UnspecifiedTable extends React.Component<any, any> {

    /**
     * Creates an instance of UnspecifiedTable.
     *
     * @param {*} props
     * @memberof UnspecifiedTable
     */
    constructor(props: any) {
        super(props)

        this.state = {
            tableItems: props.tableItems,
            // updateParentStateItems: props.updateParentStateItems,
        }

    }

    /**
     * If there are new props from the father,
     * would update its current state with the new data
     *
     * @param {*} nextProps
     * @memberof UnspecifiedTable
     */
    componentWillReceiveProps(nextProps: any) {
        this.setState({
            tableItems: nextProps.tableItems,
        })
    }

    /**
     * It creates all the elements to show in the table
     *
     * @memberof UnspecifiedTable
     */
    _createUnspecifiedTableContent = () => {
        return this.state.tableItems.map((item) => {
            let myCurreny = item.sumInsured
            return (
                <div className="table__content" key={'unspecified' + item.type}>
                    <div className="table__50-item">
                        <div className="table__50-item--row15 font_0">
                            {this._getMatchingIcon(item.type)}
                        </div>
                        <div className="table__50-item--row85">
                            {item.text}
                        </div>
                        <div className="exclude_text">
                            {item.type === 'preciousMetalsCoinsMedals' ?
                                'excludes jewellery' : null}
                            {item.type === 'clocks' ?
                                'excludes watches' : null}
                        </div>
                    </div>
                    <div className="table__30-item">
                        <div className="input full">
                            <div className="input__pound">
                                &pound;
                            </div>
                            <input
                                type="number"
                                name={item.type}
                                onChange={(event) => { this._calculateValue(event, item) }}
                                value={item.marketValue}
                                placeholder="0"
                                step="any"
                                min="0"
                                pattern={REGEXP}
                            />
                        </div>
                    </div>
                    <h4 className="table__20-item">
                        {/* £{item.sumInsured.toFixed(2)} */}
                        {(myCurreny).toLocaleString('en-GB', {
                            style: 'currency',
                            currency: 'GBP',
                        })}
                    </h4>
                </div>
            )
        })
    }

    /**
     * Generates the corresponding Icon ot the item
     * passed as parameter
     *
     * @param {String} item the item to show
     * @memberof UnspecifiedTable
     */
    _getMatchingIcon = (item: String) => {
        switch (item) {
            case 'collectiblesMemorabilia':
                return <CasksIcon />

            case 'fineWinesAndSpirits':
                return <WineIcon />

            default:
                return ''
        }
    }

    /**
     * Calculates the corresponding Selling/Cost and sum insured columns
     *
     * @param {*} event the event to trigger
     * @param {*} item the item to update
     * @memberof UnspecifiedTable
     */
    _calculateValue = (event, item) => {
        if (event.target.value !== '') {
            item.marketValue = event.target.value.replace(/^-*/, '').replace(/^0+/, '')
            if (item.marketValue === '') {
                item.marketValue = '0'
            }
            item.sumInsured = Math.ceil(parseFloat(item.marketValue) * 100) / 100
            this._updateStateItem(item)
        } else {
            item.value = Number(0)
            item.marketValue = Number(0)
            item.sumInsured = Number(0)
            this._updateStateItem(item)
        }
    }

    /**
     * Updates a new item from the tableItems
     * in the state of the component
     *
     * @param {*} itemToUpdate
     * @memberof UnspecifiedTable
     */
    _updateStateItem(itemToUpdate: any) {
        let provItems = this.state.tableItems
        this.state.tableItems.map((item, index) => {
            if (this.state.tableItems[index].type === itemToUpdate.type) {
                provItems[index] = itemToUpdate
            }
        })

        this.props.updateParentStateItems(provItems)
        this.setState({ tableItems: provItems })
    }

    render() {
        return (
            <div>
                <div className="table__titles shadow">
                    <div className="table__50-item">
                        Category of insured item
                    </div>
                    <div className="table__30-item">
                        Market value of collection
                    </div>
                    <div className="table__20-item">
                        Sum insured
                    </div>
                </div>
                {this._createUnspecifiedTableContent()}
            </div>
        )
    }
}

export default UnspecifiedTable



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Step03w/components/UnspecifiedTable.tsx